app.service('productAvailabilitySearch', function(
	_,
	productCardConfig,
	productAvailabilityService,
	productAvailabilityShopTabs
) {
	let props;
	let $self, $searchInput, $searchList;

	const ENTER_KEY_CODE = 13;

	function searchFocus() {
		$searchInput.focus();
	}

	function searchCity(cityList, searchValue) {
		const pattern = searchValue.trim();
		const regExp = new RegExp(pattern, 'gi');

		return cityList.filter(city => city.name.match(regExp));
	}

	function renderCityList(searchResults) {
		const resultList = searchResults
			.map(
				city =>
					`<div data-code="${city.code}" class="select-item js-select-city">${
						city.name
					}</div>`
			)
			.join('');

		$searchList.html(resultList);
	}

	const showCityList = _.debounce((searchValue = '') => {
		const { id: productId } = productCardConfig.getData();

		productAvailabilityService
			.getCityList({ productId })
			.then(cityList => {
				return searchValue.length < 3
					? cityList // domyślnie pokaż listę wszystkich miast
					: searchCity(cityList, searchValue);
			})
			.then(renderCityList);
	});

	function handleSearchKeyup(e) {
		showCityList(e.target.value);
	}

	function preventSubmit(e) {
		if (e.keyCode === ENTER_KEY_CODE) {
			e.preventDefault();
			$searchInput.blur();
		}
	}

	function handleSearchClear() {
		clearSearch();
		searchFocus();
		showCityList();
	}

	function handleModalClose() {
		clearSearch();
		$searchList.empty();
		productAvailabilityShopTabs.hideList();
		props.closeModal();
	}

	function clearSearch() {
		$searchInput.val('');
	}

	function handleCitySelect(e) {
		const cityCode = $(e.target).data('code');
		const city = $(e.target).text();
		const {
			id: product_id,
			buyableOnlyInShop: onlyAvailable
		} = productCardConfig.getData();

		$searchInput.val(city);
		$searchList.empty();

		const { renderShops, setState } = props;

		setState({
			city,
			cityCode
		});

		renderShops({
			city: cityCode,
			product_id,
			onlyAvailable
		});
	}

	function setElements() {
		$self = $('.product-availability');
		$searchList = $self.find('.search-list');
		$searchInput = $self.find('[name="search-city"]');
	}

	function init(newProps) {
		props = $.extend({}, newProps);

		setElements();

		$self.find('.js-close-search').on('click', handleModalClose);

		$self.find('.js-clear-search').on('click', handleSearchClear);

		$searchList.on('click', '.js-select-city', handleCitySelect);

		$searchInput
			.keyup(handleSearchKeyup)
			.keypress(preventSubmit)
			.focus(e => showCityList(e.target.value));
	}

	return { init };
});
